const COLORS = {
  primary: "#108236",
  black: "#1E1E1C",
};
export default COLORS;
